// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-topic[data-v-ccb30e76]{color:#ff764d;font-weight:700;margin:35px 0}", ""]);
// Exports
module.exports = exports;
